<template>
  <ModalDialog
    v-model="visible"
    :title="$localize('GroupSaveModalTitle')"
    :is-wide="false"
  >
    <template
      #default
    >
      <div>
        {{ $localize('GroupSaveModalText', { '0': preRegisteredUsersAssignedCount }) }}
      </div>
      <br>
      <div>
        {{ $localize('GroupSaveModalQuestion') }}
      </div>
    </template>
    <template #footer>
      <button
        ref="closeButton"
        class="btn btn-outline-secondary"
        @click="visible = false"
      >
        {{ $localize('Cancel') }}
      </button>
      <button
        ref="saveButton"
        class="btn btn-primary"
        @click="emit('save')"
      >
        {{ $localize('Save') }}
      </button>
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
  import ModalDialog from '@/VueComponents/Modals/ModalDialog';

  defineProps<{
    preRegisteredUsersAssignedCount: number
  }>();
  const emit = defineEmits<{ 'save' }>();
  const visible = defineModel<boolean>({ default: false });
</script>

<style scoped>
</style>
